export const API = window._env.REACT_APP_API_URL
export const USER_ANALYTICS = '/user-analytics'
export const SITE_LIST = '/sites'
export const LOCUS_LIST = '/locuses'
export const LOCUS_TREE = '/locuses/tree'
export const REGION_LIST = '/regions'
export const SITE_GROUPS_LIST = '/site-groups'
export const PRODUCTION_SITE_DATA_TODAY = '/production/site/{:siteId}/today'
export const HEALTH_SITE_DATA_TODAY = '/health/site/{:siteId}/today'
export const ENVIRONMENT_SITE_DATA_TODAY = '/environment/site/{:siteId}/today'
export const PRODUCTION_LOCUS_DATA_TODAY = '/production/locus/{:locusId}/today'
export const HEALTH_LOCUS_DATA_TODAY = '/health/locus/{:locusId}/today'
export const ENVIRONMENT_LOCUS_DATA_TODAY =
  '/environment/locus/{:locusId}/today'
export const POPULATION_SITES = '/sites/population/{:population}'
export const PRODUCTION_SITE_DATA_OVERTIME =
  '/production/site/{:siteId}/{:period}/{:filter}'
export const HEALTH_SITE_DATA_OVERTIME =
  '/health/site/{:siteId}/{:period}/{:filter}'
export const FEED_SITE_DATA_OVERTIME = '/feed/site/{:siteId}/{:period}'
export const ENVIRONMENT_SITE_DATA_OVERTIME =
  '/environment/site/{:siteId}/{:period}/{:filter}'
export const PRODUCTION_LOCUS_DATA_OVERTIME =
  '/production/locus/{:locusId}/{:period}/{:filter}'
export const HEALTH_LOCUS_DATA_OVERTIME =
  '/health/locus/{:locusId}/{:period}/{:filter}'
export const FEED_LOCUS_DATA_OVERTIME = '/feed/locus/{:locusId}/{:period}'
export const ENVIRONMENT_LOCUS_DATA_OVERTIME =
  '/environment/locus/{:locusId}/{:period}/{:filter}'
export const SLA_GET_CAGES = '/sla/cage-with-rates/{:siteId}/{:date}'
export const SLA_GET_CAGE_RATES = '/sla/cage-rates/{:siteId}/{:locusId}/{:date}'
export const SLA_FEED_AMOUNT = '/sla/feed-amount/{:siteId}/{:date}'
export const SLA_GET_SITE_SENSORS =
  '/sla/sensors/{:sensor}/{:dataType}/{:siteId}/{:date}'
export const SLA_CHART_FEEDING_ACTUAL =
  '/sla/chart-feeding-actual/{:siteId}/{:date}'
export const SLA_SET_CAGE_RATE = '/sla/cage-rate/{:locusId}/{:userId}'
export const SEA_LICE_LAST_DATE = '/sea-lice/{:type}'
export const USER_LIST_BY_LICENSEE = '/users/by-licensee'
export const DASHBOARD_GROWTH_LOCUS_DATA =
  '/dashboard-growth/cagedata/{:locusId}'

// users
export const USERS = '/users'
export const USER_TABLE = `${USERS}/table`
export const USER_INFO = `${USERS}/{:id}`

// auth
export const LOGIN = '/login_check'
export const LOGIN_WITH_GOOGLE = '/login/oauth'
export const LOGIN_OAUTH = '/login/oauth'
export const FORGOT_PASSWORD = `${USERS}/forgot-password`
export const RESET_PASSWORD = `${USERS}/reset-password/`
export const RESET_TOKEN = `${USERS}/check-reset-token/`

// user groups
export const USER_GROUPS = '/user-groups'
export const USER_GROUP_TABLE = `${USER_GROUPS}/table`
export const USER_GROUP_INFO = `${USER_GROUPS}/{:id}`

// profile
export const PROFILE = '/user/profile'
export const PROFILE_LICENSEE_CONTEXT = `${PROFILE}/licensee-context/{:licenseeId}`
export const PROFILE_NOTIFICATION_SETTINGS = `${PROFILE}/notification-settings`
export const PROFILE_SITE_CONTEXT = `${PROFILE}/site-context`
export const UPDATE_USER_APPLICATION = `${PROFILE}/last-application`
export const SET_MY_JOBS_FILTERS = `${PROFILE}/my-jobs-filters`
export const SET_JOBS_SORTING = `${PROFILE}/my-jobs-sorting`
export const SET_MANAGEMENT_UI_FILTERS = `${PROFILE}/jobs-management-filters`
export const SET_LOOKUP_TABLES_FILTERS = `${PROFILE}/lookup-table-filters`
export const SET_MY_JOBS_DATA_VIEWER_FILTERS = `${PROFILE}/jobs-data-viewer-filters`
export const SET_SIGNATURE = `${PROFILE}/signature`

// locus groups
export const LOCUS_GROUPS = '/locus-groups'
export const LOCUS_GROUP_TABLE = `${LOCUS_GROUPS}/table`
export const LOCUS_GROUP_INFO = `${LOCUS_GROUPS}/{:id}`

// dl
export const DL_EVENTS_LOG = '/dl/events-log/{:siteId}/{:cageId}/{:date}'
export const DL_REMOVE_LOG_ROW = '/dl/events-log/{:logId}'
export const ACTIVE_SITES = '/dl/active-sites'

// sea lice
export const SEA_LICE = '/sea-lice/{:type}/{:date}'
export const SEA_LICE_DATA =
  '/sea-lice/2/{:group}/{:neighborhood}/{:species}/{:date}'
export const SEA_LICE_SPECIES_LIST = '/sea-lice/species-list'

// barrios
export const BARRIOS_ACTIVE_LIST = '/barrios/active'

// sla
export const SITE_TOTAL_FEED = '/sites/feed-amount?site={:siteId}&date={:date}'
export const CAGE_TOTAL_FEED =
  '/locuses/feed-amount?locus={:locusId}&date={:date}'
export const SITE_FEED_ACTUAL_EXPECTED =
  '/sites/feed-actual-expected?site={:siteId}&date={:date}'
export const CAGE_FEED_ACTUAL_EXPECTED =
  '/locuses/feed-actual-expected?locus={:locusId}&date={:date}'
export const SITE_SFR_CORRECTED = '/sites/sfr?site={:siteId}&date={:date}'
export const CAGE_SFR_CORRECTED = '/locuses/sfr?locus={:locusId}&date={:date}'
export const SITE_LEFT_FEEDING =
  '/silos/days-left-feeding/site?site={:site}&date={:date}'
export const SILO_LEFT_FEEDING =
  '/silos/days-left-feeding/cages?silo={:silo}&date={:date}'
export const WEATHER_DIGEST = '/sla/weather-digest?site={:site}&now={:now}'
export const SENSORS_DIGEST = '/sla/last-sensors-data?site={:site}&date={:date}'

// environments
export const ENVIRONMENT_PEW = '/environment/pew?site={:site}&now={:now}'
export const ENVIRONMENT_HISTORICAL =
  '/environment/history?site={:site}&now={:now}&type={:type}'
export const ENVIRONMENT_FORECAST =
  '/environment/prediction?site={:site}&now={:now}&type={:type}&depth={:depth}'

// logbook
export const EVENT_DATA_LIST = '/logbook/data/events/table'
export const EVENT_DATA_ITEM = '/logbook/data/events/{:id}'
export const EVENT_FORM_LISTS = '/logbook/{:type}/form/events?site={:site}'
export const STATUS_INFO = '/sites/logbook/daily/status'
export const LOGBOOK_EVENT_LIST =
  '/logbook/{:type}/events?site={:site}&date={:date}'
export const LOGBOOK_SINGLE_EVENT =
  '/logbook/{:type}/form/event?site={:site}&event={:event}'
export const LOGBOOK_SINGLE_EVENT_FILLED = '/logbook/data/events/{:event}'
export const LOGBOOK_BATCH_INPUTS = '/logbook/daily/data/events/batch'
export const LOGBOOK_ENTRY_SAVE = '/logbook/{:type}/data/events'
export const LB_EXPORT_CSV_DATA = '/logbook/export/data/events'

// projected sites manager
export const PROJECTED_SITES_MANAGER_API = '/stocking-and-harvesting'
export const PROJECTED_SITES_MANAGER_WITH_SITE_TYPE = `${PROJECTED_SITES_MANAGER_API}/{:siteType}`
export const PROJECTED_SITES_MANAGER_WITH_SNAPSHOT = `${PROJECTED_SITES_MANAGER_API}/snapshots/{:snapshot}/{:siteType}`
export const PROJECTED_SITES_MANAGER_TABLE_DATA = `${PROJECTED_SITES_MANAGER_WITH_SITE_TYPE}/table`
export const PROJECTED_SITES_MANAGER_TABLE_SNAPSHOT_DATA = `${PROJECTED_SITES_MANAGER_WITH_SNAPSHOT}/table`
export const PROJECTED_SITES_MANAGER_ITEM = `${PROJECTED_SITES_MANAGER_WITH_SITE_TYPE}/{:id}`
export const PROJECTED_SITES_MANAGER_SNAPSHOT_ITEM = `${PROJECTED_SITES_MANAGER_WITH_SNAPSHOT}/{:id}`
export const PROJECTED_SITES_MANAGER_PROJECTIONS = `${PROJECTED_SITES_MANAGER_WITH_SITE_TYPE}/projections`
export const PROJECTED_SITES_MANAGER_SNAPSHOT_PROJECTIONS = `${PROJECTED_SITES_MANAGER_WITH_SNAPSHOT}/projections`
export const PROJECTED_SITES_MANAGER_SITE_TABLE_DATA = `${PROJECTED_SITES_MANAGER_PROJECTIONS}/table`
export const PROJECTED_SITES_MANAGER_SITE_TABLE_SNAPSHOT_DATA = `${PROJECTED_SITES_MANAGER_SNAPSHOT_PROJECTIONS}/table`
export const PROJECTED_SITES_MANAGER_ITEM_ROW = `${PROJECTED_SITES_MANAGER_PROJECTIONS}/{:id}`
export const PROJECTED_SITES_MANAGER_SNAPSHOT_ITEM_ROW = `${PROJECTED_SITES_MANAGER_SNAPSHOT_PROJECTIONS}/{:id}`
export const PROJECTED_SITES_MANAGER_SEAWATER_FILTERS = `${PROJECTED_SITES_MANAGER_WITH_SITE_TYPE}/filters`
export const PROJECTED_SITES_MANAGER_CLIENTS = `${PROJECTED_SITES_MANAGER_WITH_SITE_TYPE}/clients`
export const PROJECTED_SITES_MANAGER_SITES = `${PROJECTED_SITES_MANAGER_WITH_SITE_TYPE}/sites?clientId={:clientId}`
export const PROJECTED_SITES_MANAGER_BASE_PRODUCTS = `${PROJECTED_SITES_MANAGER_API}/base-products?productFamily={:productFamilyId}`
export const PROJECTED_SITES_MANAGER_DIET_GROUPS = `${PROJECTED_SITES_MANAGER_API}/diet-groups?productFamilyId={:productFamilyId}`
export const PROJECTED_SITES_MANAGER_PROJECTED_PRODUCTS = `${PROJECTED_SITES_MANAGER_API}/products?baseProduct={:baseProductId}`
export const PROJECTED_SITES_MANAGER_EXPORT_CSV_DATA = `${PROJECTED_SITES_MANAGER_WITH_SITE_TYPE}/export`
export const PROJECTED_SITES_MANAGER_EXPORT_CSV_SNAPSHOT_DATA = `${PROJECTED_SITES_MANAGER_WITH_SNAPSHOT}/export`
export const PROJECTED_SITES_MANAGER_REGIONS = `${PROJECTED_SITES_MANAGER_API}/regions`
export const PROJECTED_SITES_MANAGER_SPECIES = `${PROJECTED_SITES_MANAGER_API}/species`
export const PROJECTED_SITES_MANAGER_PRODUCT_FAMILY = `${PROJECTED_SITES_MANAGER_API}/product-family`
export const PROJECTED_SITES_MANAGER_LOOKUP = `${PROJECTED_SITES_MANAGER_API}/lookup/{:table}`
export const PROJECTED_SITES_MANAGER_SNAPSHOTS = `${PROJECTED_SITES_MANAGER_API}/snapshots`
export const PROJECTED_SITES_MANAGER_UPDATE_SNAPSHOT = `${PROJECTED_SITES_MANAGER_SNAPSHOTS}/{:id}`
export const PROJECTED_SITES_MANAGER_USERS_AND_GROUPS = `${PROJECTED_SITES_MANAGER_SNAPSHOTS}/users-and-groups`

// logbook form
export const LOGBOOK_FORM_LIST = '/logbook-form?site={:site}'
export const LOGBOOK_FORM_EVENT_LIST_WITH_DATA =
  '/logbook-form/{:form}/events-data'
export const LOGBOOK_FORM_EVENT_VALUES =
  '/logbook-form/single-event-forms/site-values'
export const LOGBOOK_LOCUS_GROUP_EVENT_VALUES =
  '/logbook-form/single-event-forms/locus-group-values'
export const LOGBOOK_LOCUS_EVENT_VALUES =
  '/logbook-form/single-event-forms/locus-values'

// sisense dashboard
export const SISENSE_LIST_BY_APPLICATION =
  '/sisense-dashboard/by-licensee-application/{:id}'
export const API_URL_SISENSE_LIST = '/sisense-dashboard'
export const API_URL_SISENSE_TABLE = '/sisense-dashboard/table'
export const API_URL_SISENSE_ITEM = '/sisense-dashboard/{:id}'

// licensee application dashboard
export const API_URL_LICENSEE_APPLICATION_LIST = '/licensee-application'
export const API_URL_LICENSEE_APPLICATION_TABLE = '/licensee-application/table'
export const API_URL_LICENSEE_APPLICATION_ITEM = '/licensee-application/{:id}'

// feedback
export const SAVE_FEEDBACK_FORM = '/feedback'

// sensors
export const SENSOR_SET_LIMITS = '/sensor-max-value'
export const ACTIVE_SITE_TYPE_LIST = '/site-types/active'
export const SENSOR_TYPES =
  '/sensors/sensor-types?site={:site}&from={:from}&to={:to}'
export const SENSOR_NAMES =
  '/sensors?site={:site}&from={:from}&to={:to}&{:sensor_types}'
export const SENSORS_DATA =
  '/sensors/ecto-sensor-groups?site={:site}&from={:from}&to={:to}&{:sensor_types}'

// Monitoring alerts
export const MONITORING_ALERTS_POLICIES = '/monitoring-alerts/policies'
export const MONITORING_ALERTS_INDICATORS =
  '/monitoring-alerts/policy-indicators'
export const MONITORING_ALERTS_INDICATORS_TABLE =
  '/monitoring-alerts/policy-indicators/table'
export const MONITORING_ALERTS_POLICY_EDITOR_LIST =
  '/monitoring-alerts/notification-settings'
export const MONITORING_ALERTS_SITE_LIST = '/monitoring-alerts/sites'
export const MONITORING_ALERTS_LOCUS_LIST = '/monitoring-alerts/locuses'

// Data browser
export const DB_LOGBOOK_EVENT_LIST = '/data-browser/logbook-data/events'
export const DB_PRODUCTION_AND_HEALTH_DATA =
  '/data-browser/production-and-health/'
export const DB_ENVIRONMENT_DATA = '/data-browser/environment-data/sensor-data'
export const DB_SENSORS =
  '/data-browser/environment-data/sensors?site={:site}&from={:from}&to={:to}'
export const DB_LOGBOOK_DATA = '/data-browser/logbook-data/event-data'
export const DB_EXPORT_CSV_DATA = '/data-browser/export'

// Licensees
export const LICENSEE_UPDATE_LOGO = '/licensees/{:licensee}/upload/logo'

// upload files
export const UPLOAD_FILES = '/files/logbook'
export const REMOVE_FILES = '/files/{:id}'

// applications
export const APPLICATIONS = '/applications'
export const APPLICATIONS_TABLE = `${APPLICATIONS}/table`
export const APPLICATIONS_BY_LICENSEE = `${APPLICATIONS}/licensee`
export const APPLICATIONS_BY_USER = `${APPLICATIONS}/my`
export const APPLICATION_INFO = `${APPLICATIONS}/{:id}`
export const APPLICATION_UPLOAD_ICON = `${APPLICATIONS}/{:id}/upload/icon`
export const APPLICATION_UPLOAD_SMALL_ICON = `${APPLICATIONS}/{:id}/upload/small-icon`

// site groups
export const SITE_GROUPS = '/site-groups'
export const SITE_GROUP_TABLE = `${SITE_GROUPS}/table`
export const SITE_GROUP_INFO = `${SITE_GROUPS}/{:id}`
export const SITE_GROUPS_HIERARCHICAL = `${SITE_GROUPS}/hierarchical`

// my jobs
export const MY_JOBS = '/jobs'
export const MY_JOB_TASKS = '/job-tasks'
export const MY_JOB_FILTERS = `${MY_JOBS}/filters`
export const MY_JOB_TABLE = `${MY_JOBS}/table`
export const MY_JOBS_UPDATE_JOB = `${MY_JOBS}/{:id}/{:action}`
export const JOB_GENERATE_REPORT = `${MY_JOBS}/{:job}/reports/{:jobToReportTemplate}`
export const MY_JOBS_WORKFLOWS = '/job-workflows'
export const MY_JOBS_INPUTS = '/job-inputs'
export const MY_JOBS_ADD_DYNAMIC_OPTION = `${MY_JOBS_INPUTS}/{:id}/options`
export const MY_JOBS_EVENT_LIST = `${MY_JOBS_INPUTS}/evts`
export const MY_JOBS_EVALUATE_CALCULATION_FIELD = `${MY_JOBS_EVENT_LIST}/evaluate/bulk?input={:inputId}`
export const MY_JOBS_MULTI_EVENT_LIST = `${MY_JOBS_INPUTS}/evt-inputs`
export const MY_JOBS_TASKS_EVENTS = `${MY_JOB_TASKS}/evts`
export const MY_JOBS_TASKS_MULTI_EVENTS = `${MY_JOB_TASKS}/evt-tasks`
export const MY_JOBS_UPLOAD_FILES = '/files/my-jobs'
export const MY_JOBS_UPLOAD_MULTIPLE_FILES = '/files/my-jobs/multiple'
export const MY_JOBS_UPDATE_TASK = `${MY_JOB_TASKS}/{:id}/{:action}`
export const MY_JOBS_UPDATE_TASK_ASSIGNEES = `${MY_JOB_TASKS}/{:id}`
export const MY_JOBS_UPDATE_SERIAL_TASK_ASSIGNEES = `${MY_JOBS_UPDATE_TASK_ASSIGNEES}/job-series`
export const MY_JOBS_LOOKUP_TABLE_SOURCE_DATA = `${MY_JOBS_INPUTS}/{:id}/lookup-table-source-data`
export const JOB_SERIES = '/job-series'
export const JOB_SERIES_RECOVER = `${JOB_SERIES}/{:id}/recover`
export const MY_JOBS_UPLOAD_FILE = '/files/my-jobs/data-url'

// my jobs data viewer
export const JOB_WORKFLOW_POSITION_CHANGE = '/{:type}/{:id}'
export const MY_JOBS_DATA_VIEWER = '/jobs-data-viewer'
export const MY_JOBS_DATA_VIEWER_FILTERS = `${MY_JOBS_DATA_VIEWER}/filters`
export const MY_JOBS_DATA_VIEWER_TABLE = `${MY_JOBS_DATA_VIEWER}/data/table`
export const DATA_VIEWER_EXPORT_CSV = `${MY_JOBS_DATA_VIEWER}/data/export`

// jobs workflow tasks
export const JOB_WORKFLOW_TASKS = '/job-workflow-tasks'
export const JOB_WORKFLOW_TASKS_TABLE = `${JOB_WORKFLOW_TASKS}/table`
export const JOB_WORKFLOW_TASK_UPDATE = `${JOB_WORKFLOW_TASKS}/{:id}`
export const JOB_WORKFLOW_TASK_INFO = `${JOB_WORKFLOW_TASKS}/{:id}/details`
export const JOB_WORKFLOW_TASK_NUMBERS = `${JOB_WORKFLOW_TASKS}/{:id}/numbers`
export const JOB_WORKFLOW_TASK_LOOKUP_CONDITIONS = `${JOB_WORKFLOW_TASKS}/{:id}/lookup-conditions`
export const JOB_WORKFLOW_TASK_POLICIES = `${JOB_WORKFLOW_TASKS}/policies`
export const JOB_WORKFLOW_TASK_ASSIGNMENTS = `${JOB_WORKFLOW_TASKS}/{:id}/assignments`
export const JOB_WORKFLOW_TASK_ASSIGNMENTS_UPDATE = `${JOB_WORKFLOW_TASKS}/{:id}/assignments/{:siteId}`
export const JOB_WORKFLOW_TASK_INPUT_TREE = `${JOB_WORKFLOW_TASKS}/{:id}/input-items-tree`

// job workflow admin dashboard
export const API_URL_JOB_WORKFLOW_LIST = '/job-workflows'
export const API_URL_JOB_WORKFLOW_TABLE = `${API_URL_JOB_WORKFLOW_LIST}/table`
export const API_URL_JOB_WORKFLOW_ITEM = `${API_URL_JOB_WORKFLOW_LIST}/{:id}/details`
export const API_URL_JOB_WORKFLOW_TRIGGERED_BY = `${API_URL_JOB_WORKFLOW_LIST}/{:id}/triggered-by?{:sites}`
export const API_URL_JOB_WORKFLOW_COPY_DATA = `${API_URL_JOB_WORKFLOW_LIST}/{:id}/duplicate`

// job workflow inputs
export const JOB_WORKFLOWS = '/job-workflows'
export const JOB_WORKFLOW_INPUTS = '/job-workflow-inputs'
export const JOB_WORKFLOW_INPUTS_ITEM = `${JOB_WORKFLOW_INPUTS}/{:id}`
export const JOB_WORKFLOW_INPUTS_TABLE = `${JOB_WORKFLOW_INPUTS}/table`
export const JOB_WORKFLOW_INPUTS_DETAILS = `${JOB_WORKFLOW_INPUTS_ITEM}/details`
export const JOB_WORKFLOW_INPUTS_TYPE = `${JOB_WORKFLOW_INPUTS}/types`
export const JOB_WORKFLOW_INPUTS_DISPLAY_OPTIONS = `${JOB_WORKFLOW_INPUTS}/display-options`
export const JOB_WORKFLOW_INPUTS_OPTIONS_SOURCE = `${JOB_WORKFLOW_INPUTS}/options-source`

// job workflow input items
export const JOB_WORKFLOW_INPUT_ITEMS = '/job-workflow-input-items'
export const JOB_WORKFLOW_INPUT_ITEMS_TABLE = `${JOB_WORKFLOW_INPUT_ITEMS}/table`

// job workflow input groups
export const JOB_WORKFLOW_INPUT_GROUPS = '/job-workflow-input-groups'
export const JOB_WORKFLOW_INPUT_GROUPS_ITEM = `${JOB_WORKFLOW_INPUT_GROUPS}/{:id}`
export const JOB_WORKFLOW_INPUT_GROUPS_TABLE = `${JOB_WORKFLOW_INPUT_GROUPS}/table`
export const JOB_WORKFLOW_INPUT_GROUPS_DETAILS = `${JOB_WORKFLOW_INPUT_GROUPS_ITEM}/details`
export const JOB_WORKFLOW_INPUT_GROUPS_LOOKUPS = `${JOB_WORKFLOW_INPUT_GROUPS_ITEM}/lookups`

// job input groups
export const JOB_INPUT_GROUPS = '/job-input-groups'
export const JOB_INPUT_GROUPS_ITEM = `${JOB_INPUT_GROUPS}/{:id}`
export const JOB_INPUT_GROUPS_DUPLICATE = `${JOB_INPUT_GROUPS_ITEM}/{:action}`

// Management UI
export const MANAGEMENT_UI = '/jobs-management'
export const MANAGEMENT_UI_FILTERS = `${MANAGEMENT_UI}/filters`

// Lookup Tables
export const LOOKUP_TABLES = '/lookup-tables'
export const LOOKUP_TABLES_TABLE = `${LOOKUP_TABLES}/table`
export const LOOKUP_TABLE_DATA = '/lookup-table-objects/{:id}'
export const LOOKUP_TABLE_DATA_EXPORT_CSV_DATA =
  '/lookup-table-objects/{:id}/export'
export const LOOKUP_TABLE_DATA_TABLE = `${LOOKUP_TABLE_DATA}/table`
export const LOOKUP_TABLE_DATA_BATCH = `${LOOKUP_TABLE_DATA}/batch`
export const LOOKUP_TABLES_SOURCE = `${LOOKUP_TABLES}/sources`
export const LOOKUP_TABLES_FILTERS = `${LOOKUP_TABLES}/filters`

// Jobs Triggers
export const TRIGGER_RULES = '/trigger-rules'
export const TRIGGER_INPUTS = `${TRIGGER_RULES}/inputs?workflow={:id}`
export const TRIGGER_EXISTS = `${TRIGGER_RULES}/exists`
export const TRIGGER_TABLE = `${TRIGGER_RULES}/table`
export const RULE_ACTION = `${TRIGGER_RULES}/{:id}`
export const DUPLICATE_RULE = `${TRIGGER_RULES}/{:id}/duplicate`
export const DEFAULT_ASSIGNMENTS = `${TRIGGER_RULES}/default-assignments?triggeredJobWorkflow={:triggeredJobWorkflowId}&site={:siteId}`

// Feature Flags
export const FEATURE_FLAGS = '/feature-flags'
export const FEATURE_FLAGS_INFO = `${FEATURE_FLAGS}/{:id}`

// Pdf reports
export const PDF_REPORTS = '/pdf-reports'
export const PDF_REPORTS_TABLE = `${PDF_REPORTS}/table`
